import { SCard } from 'components/shared/s-polaris';
import { useRequestProviderModal } from 'features/settings/components/ppoints/shipping-providers/cards/hooks/useRequestProviderModal';
import { useTranslation } from 'react-i18next';

/**
 * Wizard counterpart of the settings page's `RequestProviderCard`. The wizard already sits inside
 * an `s-section`, so this renders the "Can't find a shipping provider?" block as a nested section
 * of its own instead of reusing the card, whose own `s-section` shell is meant for the top level.
 */
export const RequestProviderSection: React.FC<RequestProviderSectionProps> = ({ selectedCountryCode }) => {
    const { t } = useTranslation();
    const { openRequestProviderModal } = useRequestProviderModal();

    return (
        <SCard>
            <div className="flex flex-col items-start gap-3">
                <s-heading>{t('SHIPPING_PROVIDERS.REQUEST_PROVIDER.TITLE')}</s-heading>
                <s-paragraph>{t('SHIPPING_PROVIDERS.REQUEST_PROVIDER.DESCRIPTION')}</s-paragraph>
                <s-button onClick={() => openRequestProviderModal(selectedCountryCode)}>
                    {t('SHIPPING_PROVIDERS.REQUEST_PROVIDER.BUTTON')}
                </s-button>
            </div>
        </SCard>
    );
};

interface RequestProviderSectionProps {
    selectedCountryCode?: string;
}
